// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__VRr1a","body":"tabs_body__j3LEM","link":"tabs_link__Sj40X","active":"tabs_active__Mi0wp"};